import React from "react";
import docImage from "../asset/images/partner-portal/photo-img.svg";
import deleteImg from "../asset/images/revamp-images/delete.svg";
import eyeIcon from "../asset/images/partner-portal/eye.svg";
import checkCircle from "../asset/images/revamp-images/check_circle.svg";

const DigiDocumentUploader = ({
  label,
  docKey,
  fileState,
  setFile,
  error,
  setError,
  onDelete,
  onPreview,
  documentData,
  handleUpload,
  optional,
}) => {
  const isAvailable = documentData[docKey]?.isAvailable;
  const fileName = documentData[docKey]?.name || fileState?.name;

  return (
    <div className="list-col digi-list-col">
      <div className="form-group pan-input custom-suggest partner-form">
        <div className="pan-data digi-data">
        <div className="wrap-digi-section">
          <div className="label-wrapper">
            <label className="doc-name">
              {label}
              {!optional && <span className="mandatory-label">*</span>}
            </label>
            {isAvailable && (
              <label className="green-text">
                Uploaded <img src={checkCircle} alt="check_circle" />
              </label>
            )}
          </div>
          {/* {!isAvailable && <label>Upload self-attested document</label>} */}
          {isAvailable ? (
            <div className="doc-uploaded">
              {/* <div className="preview-text"> */}
                      <span 
                      className="icon-text" 
                      type="button" 
                      onClick={() =>
                        onPreview(
                          documentData[docKey]?.url,
                          documentData[docKey]?.name || fileState?.name
                        )
                      }
                      >
                        <img src={eyeIcon} alt="eye icon" /> Preview
                      </span>
                    {/* </div> */}
            </div>
          ) : error ? (
            <div className="image" id="uploadimg">
              <span className="forget-link wrong-format doc-error">{error}</span>
            </div>
          ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DigiDocumentUploader;